import React, { useState } from 'react';
import GalleryObject from './GalleryObject';
import GalleryForm from './GalleryForm';

const className = 'h-170px w-170px';

const GallerySave = ({
  selectedObjects, saveGallery, galleryData, inputHandler, setShowForm, sendGallery, inputObjectHandler, toggleTag,
}) => (
  <div>
    <div className="flex flex-row px-2">
      {selectedObjects && (
        <p className="font-americaMonoBold text-xs uppercase m-0 bg-greyFilter  rounded h-30px py-1 px-4 text-center mr-5 text-black">
          <span className="font-icon icon-stack pr-2" />
          {selectedObjects.length}
          {' '}
          {selectedObjects.length === 1 ? 'file added' : 'files added'}
        </p>
      )}
      <div className="text-xs font-americaMonoRegular uppercase border-1 border-white rounded-full px-5 py-1 cursor-default mb-4 w-32 flex-row justify-around flex h-30px items-center cursor-pointer z-1" onClick={() => setShowForm()}>
        add more
        <span className="font-icon icon-add-button font-black" />
      </div>
    </div>
    <div className="flex justify-between">
      <div className="flex flex-row flex-wrap mb-4 content-start overflow-y-auto max-h-46 -m-2 max-w-xl pl-3 justify-start min-w-58">
        {selectedObjects
          && selectedObjects.map(obj => (
            <div key={obj.assetSlugName} className={`border border-greyFilter rounded m-8px px-3 pb-5 w-210px h-275px flex flex-col items-center ${obj.fileReadableName.en ? 'justify-center' : 'justify-evenly'}`}>
              <GalleryObject {...obj} className={className} cursor gallerySave selectedObjects={selectedObjects} />
              <p className="text-xs break-all pt-4">{obj.fileReadableName && obj.fileReadableName.en.substring(0, 30)}</p>
            </div>
          ))}
      </div>
      <div className="flex w-44 pr-2 pb-7">
        <GalleryForm toggleTag={toggleTag} selectedObjects={selectedObjects} saveGallery={saveGallery} galleryData={galleryData} inputObjectHandler={inputObjectHandler} inputHandler={inputHandler} sendGallery={sendGallery} />
      </div>
    </div>
  </div>
);
export default GallerySave;
